import { Box } from '@mui/material';
import colors from '../../../../../assets/theme/base/colors';

interface IndividualJustificationStatsSummaryProps {
    needing: number;
    captured: number;
    outstanding: number;
    isLoading: boolean;
}

export function IndividualJustificationStatsSummary({ needing, captured, outstanding, isLoading }: IndividualJustificationStatsSummaryProps) {
    const cells = [
        { label: 'Needing Justification', value: needing, valueColor: colors.dark.main },
        { label: 'Captured', value: captured, valueColor: colors.dark.main },
        { label: 'Outstanding', value: outstanding, valueColor: outstanding > 0 ? colors.error.main : colors.dark.main },
    ];

    return (
        <Box
            sx={{
                display: 'flex',
                border: `1px solid ${colors.ui.border}`,
                borderRadius: '8px',
                backgroundColor: colors.white.main,
                overflow: 'hidden',
            }}
        >
            {cells.map((cell, index) => (
                <Box
                    key={cell.label}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        px: 2,
                        py: 0.75,
                        minWidth: 88,
                        borderRight: index < cells.length - 1 ? `1px solid ${colors.ui.border}` : 'none',
                    }}
                >
                    <Box sx={{ fontSize: '1rem', fontWeight: 700, lineHeight: 1.2, color: cell.valueColor }}>
                        {isLoading ? '—' : cell.value}
                    </Box>
                    <Box sx={{ fontSize: '0.625rem', color: colors.ui.secondaryText, lineHeight: 1.2, textAlign: 'center' }}>
                        {cell.label}
                    </Box>
                </Box>
            ))}
        </Box>
    );
}
